<div class="sngpc-pagina">
    <div class="sngpc-cabecalho">
        <div>
            <h1 style="font-size: 24px; margin: 0px;">SNGPC</h1>
            <div class="sngpc-cliente">
                {{cliente?.RAZAO_SOCIAL}}
                <span *ngIf="cliente?.CPF_CNPJ"> · {{cliente.CPF_CNPJ | cpfCnpj}}</span>
                <span *ngIf="cliente?.NOME_BANCO"> · banco {{cliente.NOME_BANCO}}</span>
            </div>
        </div>
        <button pButton icon="fa fa-arrow-left" label="Voltar" class="p-button-secondary" (click)="voltar()"></button>
    </div>

    <p class="sngpc-ajuda">
        O SNGPC e ligado por empresa (cada farmacia tem CNPJ proprio no toqSNGPC).
        Depois de ligar, passe a <b>URL da API</b> e a <b>chave</b> para a farmacia colar no toqSNGPC,
        em <i>Integracao ERP</i> (campos "URL da API" e "API Token").
    </p>

    <p-table [value]="empresas" [loading]="carregando" dataKey="IdEmpresa" styleClass="sngpc-tabela">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 30%">Empresa</th>
                <th style="width: 17%">CNPJ</th>
                <th style="width: 11%">SNGPC</th>
                <th style="width: 42%">Integracao com o toqSNGPC</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
            <tr>
                <td>
                    <div>{{e.NomeFantasia || e.RazaoSocial}}</div>
                    <small class="sngpc-sub">{{e.RazaoSocial}} · {{e.Matriz ? 'empresa principal' : 'filial'}} · id {{e.IdEmpresa}}</small>
                </td>
                <td class="sngpc-cnpj">{{e.Cnpj | cpfCnpj}}</td>
                <td>
                    <span class="sngpc-status" [class.ligado]="e.SngpcAtivo">{{e.SngpcAtivo ? 'Ligado' : 'Desligado'}}</span>
                    <div style="margin-top: 6px;">
                        <button pButton [label]="e.SngpcAtivo ? 'Desligar' : 'Ligar'"
                                [class]="e.SngpcAtivo ? 'p-button-sm p-button-danger p-button-outlined' : 'p-button-sm p-button-success'"
                                [disabled]="ocupado[e.IdEmpresa]" (click)="alternarAtivo(e)"></button>
                    </div>
                </td>
                <td>
                    <ng-container *ngIf="e.IntegrationKey; else semChave">
                        <div class="sngpc-campo">
                            <label>URL da API</label>
                            <code>{{e.UrlApi}}</code>
                            <button pButton icon="fa fa-copy" class="p-button-sm p-button-text" pTooltip="Copiar URL"
                                    (click)="copiar(e.UrlApi, 'URL')"></button>
                        </div>
                        <div class="sngpc-campo">
                            <label>Chave (API Token)</label>
                            <code>{{chaveExibida(e)}}</code>
                            <button pButton [icon]="chaveVisivel[e.IdEmpresa] ? 'fa fa-eye-slash' : 'fa fa-eye'"
                                    class="p-button-sm p-button-text" [pTooltip]="chaveVisivel[e.IdEmpresa] ? 'Ocultar' : 'Mostrar'"
                                    (click)="chaveVisivel[e.IdEmpresa] = !chaveVisivel[e.IdEmpresa]"></button>
                            <button pButton icon="fa fa-copy" class="p-button-sm p-button-text" pTooltip="Copiar chave"
                                    (click)="copiar(e.IntegrationKey, 'Chave')"></button>
                        </div>
                        <div *ngIf="!e.SngpcAtivo" class="sngpc-aviso">
                            Desligado: o toqSNGPC recebe "SNGPC desativado" ao usar esta chave.
                        </div>
                        <button pButton label="Gerar nova chave" icon="fa fa-refresh"
                                class="p-button-sm p-button-warning p-button-outlined" style="margin-top: 6px;"
                                [disabled]="ocupado[e.IdEmpresa]" (click)="gerarNovaChave(e)"></button>
                    </ng-container>
                    <ng-template #semChave>
                        <span class="sngpc-sub">Sem chave. Ao ligar o SNGPC, a chave e gerada.</span>
                    </ng-template>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4">{{carregando ? 'Carregando...' : 'Nenhuma empresa encontrada para este cliente.'}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog key="sngpc" icon="pi pi-exclamation-triangle" [style]="{width: '480px'}"></p-confirmDialog>
